var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToysAndBoardGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Board-Game-Dice-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Board Game Dice 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.91 3.46 12.8 0.12a2.75 2.75 0 0 0 -1.63 0L2.09 3.46a0.55 0.55 0 0 0 0 1l9.72 3.9a0.47 0.47 0 0 0 0.4 0l9.72 -3.9a0.55 0.55 0 0 0 -0.02 -1ZM12 5.45a1.09 1.09 0 1 1 1.09 -1.09A1.09 1.09 0 0 1 12 5.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.58 13.16 9.64a0.53 0.53 0 0 0 -0.34 0.51v13.3a0.54 0.54 0 0 0 0.75 0.5c2.4 -1 9.67 -4.2 9.67 -4.2a1.26 1.26 0 0 0 0.76 -1.16V6.09a0.55 0.55 0 0 0 -0.75 -0.51Zm-6.89 13.93a1.09 1.09 0 1 1 1.09 -1.09 1.09 1.09 0 0 1 -1.09 1.09Zm2.19 -3.81a1.1 1.1 0 1 1 1.09 -1.1 1.1 1.1 0 0 1 -1.09 1.1Zm2.18 -3.82a1.09 1.09 0 1 1 1.09 -1.09 1.09 1.09 0 0 1 -1.09 1.09Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.84 9.64 0.75 5.58a0.55 0.55 0 0 0 -0.75 0.51v12.5a1.26 1.26 0 0 0 0.76 1.16S8 22.92 10.43 24a0.54 0.54 0 0 0 0.75 -0.5V10.15a0.53 0.53 0 0 0 -0.34 -0.51Zm-7 3.87a1.09 1.09 0 1 1 1.09 -1.09 1.09 1.09 0 0 1 -1.11 1.09Zm3.27 4.91a1.09 1.09 0 1 1 1.09 -1.09 1.09 1.09 0 0 1 -1.11 1.09Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToysAndBoardGames);
export default ForwardRef;